// extracted by mini-css-extract-plugin
export default {"main":"future_mLDU6IS2EBMd","overlay":"future_lxHpah5A0Mnv","background":"future_LMHLUPYK84rR","iconFloatRight":"future_mzyVlXL_o7bG"};